export default "__VITE_ASSET__BMZ0HYz5__"